import Vue from 'vue'

export const GridEvents = new Vue()
